import React from 'react';
import { Widget } from '../Widget';
import { BarSeries, SeriesPoint } from '../BarSeries';
import { useGovernance } from '../../../contexts/GovernanceContext';
import { auditInScope } from '../../../utils/auditScope';
const DAYS = 14;

/**
 * Counted, not modelled. Each bar is the number of audit entries recorded on
 * that day within the scope being viewed — so the chart cannot disagree with
 * the feed beside it, and there is no smoothing or projection to mislead.
 */
export function ActivityChartWidget() {
  const {
    audit,
    activeScope,
    scopeLabel
  } = useGovernance();
  const label = scopeLabel(activeScope);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const buckets: SeriesPoint[] = [];
  for (let offset = DAYS - 1; offset >= 0; offset -= 1) {
    const day = new Date(today);
    day.setDate(today.getDate() - offset);
    buckets.push({
      label: day.toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short'
      }),
      value: 0
    });
  }
  const earliest = new Date(today);
  earliest.setDate(today.getDate() - (DAYS - 1));
  let counted = 0;
  audit.forEach(record => {
    if (!auditInScope(record.scope, activeScope, label)) return;
    const at = new Date(record.at);
    at.setHours(0, 0, 0, 0);
    const index = Math.round((at.getTime() - earliest.getTime()) / 86400000);
    if (index < 0 || index >= DAYS) return;
    buckets[index].value += 1;
    counted += 1;
  });
  return <Widget title="Recorded administrative activity" description={`Audit entries per day for the last ${DAYS} days, within ${label}.`} state={counted ? 'ready' : 'empty'} emptyTitle="No activity recorded in this period" emptyDescription={`Nothing was written to the audit log in the last ${DAYS} days within this scope. Older entries remain in the audit log.`} footnote="Counts every entry, including refused attempts. A day with no bar had no recorded activity — not missing data." data-id="element-496" data-mp="2nxb6x4jfehns">
      <BarSeries points={buckets} unit="audit entries" caption={`${counted} entries across ${DAYS} days.`} data-id="element-497" data-mp="yi3cznp3kdc9" />
    </Widget>;
}